export default __webpack_public_path__ + "static/media/shittycot.7451cdfa.png";